import type { ReactElement } from "react";

export type TransitionDuration = number | { enter?: number; leave?: number };

export function resolveTimeout(duration?: TransitionDuration): { enter: number; exit: number } {
  if (typeof duration === "number") return { enter: duration, exit: duration };
  if (duration) {
    return {
      enter: duration.enter ?? 200,
      exit: duration.leave ?? duration.enter ?? 200
    };
  }
  return { enter: 200, exit: 200 };
}

export function assignRef(ref: unknown, value: Element | null): void {
  if (!ref) return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  if (typeof ref === "object" && "current" in ref) {
    (ref as { current: Element | null }).current = value;
  }
}

export function extractRef(element: ReactElement): unknown {
  const el = element as unknown as Record<string, unknown>;
  return el["ref"] ?? (element.props as Record<string, unknown> | undefined)?.["ref"];
}

export function mergeClasses(...classNames: Array<string | undefined>): string {
  return classNames.filter(Boolean).join(" ");
}
